{
  "AUTOMATION": {
    "HEADER": "Automatizacija",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Dodaj pravilo automatizacije",
    "LOADING": "Prikupljanje pravila automatizacije",
    "ADD": {
      "TITLE": "Dodaj pravilo automatizacije",
      "SUBMIT": "Napravi",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "FORM": {
        "NAME": {
          "LABEL": "Naziv pravila",
          "PLACEHOLDER": "Unesite naziv pravila",
          "ERROR": "Ime je neophodno"
        },
        "DESC": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Unesite opis pravila",
          "ERROR": "Opis je neophodan"
        },
        "EVENT": {
          "LABEL": "Događaj",
          "PLACEHOLDER": "Molim izaberite jedno",
          "ERROR": "Događaj je obavezan"
        },
        "PHASE": {
          "LABEL": "Faza"
        },
        "ORDER": {
          "LABEL": "Redosled",
          "ERROR": "Redosled je obavezan"
        },
        "CONDITIONS": {
          "LABEL": "Uslovi"
        },
        "ACTIONS": {
          "LABEL": "Akcije"
        }
      },
      "CONDITION_BUTTON_LABEL": "Dodaj uslov",
      "ACTION_BUTTON_LABEL": "Dodaj akciju",
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije je uspešno dodato",
        "ERROR_MESSAGE": "Nije bilo moguće napraviti pravilo automatizacije. Molim vas pokušajte ponovo"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Faza",
        "ORDER": "Redosled",
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "ACTIVE": "Aktivno",
        "CREATED_ON": "Napravljeno",
        "WAIT": "Čekanje"
      },
      "404": "Nisu pronađena pravila automatizacije",
      "TABS": {
        "ALL": "Sva",
        "INSTANT": "Pri događaju",
        "DELAYED": "Sa odlaganjem"
      },
      "WAITS": "Čeka {duration}"
    },
    "DELETE": {
      "TITLE": "Obriši pravilo automatizacije",
      "SUBMIT": "Izbriši",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "CONFIRM": {
        "TITLE": "Potvrdite brisanje",
        "MESSAGE": "Sigurni ste da želite izbrisati ",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      },
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije je uspešno obrisano",
        "ERROR_MESSAGE": "Nije bilo moguće obrisati pravilo automatizacije. Molim vas pokušajte ponovo"
      }
    },
    "EDIT": {
      "TITLE": "Uredi pravilo automatizacije",
      "SUBMIT": "Primeni",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije je uspešno izmenjeno",
        "ERROR_MESSAGE": "Nije bilo moguće izmeniti pravilo automatizacije. Molim vas pokušajte ponovo"
      }
    },
    "CLONE": {
      "TOOLTIP": "Kloniraj",
      "API": {
        "SUCCESS_MESSAGE": "Automatizacija je uspešno klonirana",
        "ERROR_MESSAGE": "Nije bilo moguće klonirati pravilo automatizacije. Molim vas pokušajte ponovo"
      }
    },
    "FORM": {
      "EDIT": "Uredi",
      "CREATE": "Napravi",
      "DELETE": "Izbriši",
      "CANCEL": "Otkaži",
      "RESET_MESSAGE": "Promena tipa događaja će resetovati uslove i događaje koje ste dodali ispod"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Morate imati barem jedan uslov da bi ste mogli da sačuvate",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Morate imati barem jednu akciju da bi ste mogli da sačuvate",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Unesite ovde vašu poruku",
      "TEAM_DROPDOWN_PLACEHOLDER": "Izaberite timove",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Izaberite sandučić e-pošte i adresu pošiljaoca",
      "SUBJECT_INPUT_PLACEHOLDER": "Naslov e-poruke",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Izaberite SMS sandučić iz kog će se SMS poslati",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Unesite tekst SMS-a",
      "SMS_COUNTER": "{length}/{limit} znakova, {segments} SMS (pre popunjavanja promenljivih)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktiviraj pravilo automatizacije",
      "DEACTIVATION_TITLE": "Deaktiviraj pravilo automatizacije",
      "ACTIVATION_DESCRIPTION": "Ova akcija će aktivirati pravilo automatizacije '{automationName}'. Da li zaista želite da nastavite?",
      "DEACTIVATION_DESCRIPTION": "Ova akcija će deaktivirati pravilo automatizacije '{automationName}'. Da li zaista želite da nastavite?",
      "ACTIVATION_SUCCESFUL": "Pravilo automatizacije je uspešno aktivirano",
      "DEACTIVATION_SUCCESFUL": "Pravilo automatizacije je uspešno deaktivirano",
      "ACTIVATION_ERROR": "Nije bilo moguće aktivirati automatizaciju. Molim vas pokušajte ponovo",
      "DEACTIVATION_ERROR": "Nije bilo moguće deaktivirati automatizaciju. Molim vas pokušajte ponovo",
      "CONFIRMATION_LABEL": "Da",
      "CANCEL_LABEL": "Ne"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nije bilo moguće dodati prilog. Molim vas pokušajte ponovo",
      "LABEL_IDLE": "Dodaj prilog",
      "LABEL_UPLOADING": "Dodavanje...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Dodavanje nije uspelo"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Vrednost je neophodna",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ova akcija funkcioniše samo kada je faza pravila podešena na 'Pre označavanja'.",
      "SKIP_AUTO_LABELING": "Ova akcija funkcioniše samo kada je faza pravila podešena na 'Pre označavanja'.",
      "MOVE_CONVERSATION_TO_INBOX": "U prijemni sandučić e-pošte mogu se premestiti samo razgovori putem e-pošte i veb četa, a veb čet samo ako kontakt ima adresu e-pošte. U suprotnom razgovor ostaje gde jeste, a umesto toga se dodaje privatna beleška.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Započinje novi razgovor sa kontaktom u izabranom sandučiću e-pošte, šalje mu poruku e-poštom i označava razgovor kao rešen. To se dešava svaki put kada se pravilo pokrene. Ako kontakt nema adresu e-pošte, ništa se ne šalje i umesto toga se dodaje privatna beleška.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Započinje novi razgovor sa kontaktom u izabranom SMS sandučiću, šalje mu poruku kao SMS i označava razgovor kao rešen. To se dešava svaki put kada se pravilo pokrene. Poruka je običan tekst bez priloga. Ako kontakt nema broj telefona, ništa se ne šalje i umesto toga se dodaje privatna beleška."
    },
    "NOTICES": {
      "AI_PROMPT": "Svako pojedinačno ocenjivanje se naplaćuje.",
      "INCOMING_MESSAGES_COUNT": "Ovo se odnosi na broj dolaznih poruka u razgovoru.",
      "OUTGOING_MESSAGES_COUNT": "Ovo se odnosi na broj izlaznih poruka u razgovoru."
    },
    "PHASE": {
      "BEFORE_LABELING": "Pre označavanja",
      "AFTER_LABELING": "Posle označavanja"
    },
    "NONE_OPTION": "Niko",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Da",
      "NO": "Ne"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Direktna poruka na Instagramu",
      "FACEBOOK_COMMENT": "Komentar na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Razgovor je napravljen",
      "CONVERSATION_UPDATED": "Razgovor je izmenjen",
      "MESSAGE_CREATED": "Poruka je napravljena",
      "CONVERSATION_OPENED": "Razgovor je otvoren",
      "CONVERSATION_RESOLVED": "Razgovor je rešen",
      "PHONE_CALL_FINISHED": "Poziv je završen"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Dodeli agentu",
      "ASSIGN_TEAM": "Dodeli tim",
      "ADD_LABEL": "Dodaj oznaku",
      "REMOVE_LABEL": "Ukloni oznaku",
      "SEND_EMAIL_TO_TEAM": "Pošalji e-poštu timu",
      "SEND_EMAIL_TRANSCRIPT": "Pošalji transkript putem e-pošte",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Pošalji detaljan transkript putem e-pošte",
      "MUTE_CONVERSATION": "Utišaj razgovor",
      "SNOOZE_CONVERSATION": "Odloži razgovor",
      "RESOLVE_CONVERSATION": "Reši razgovor",
      "OPEN_CONVERSATION": "Otvori razgovor",
      "SEND_WEBHOOK_EVENT": "Pošalji događaj putem veb zakačke",
      "SEND_ATTACHMENT": "Pošalji prilog",
      "SEND_MESSAGE": "Pošalji poruku",
      "ADD_NOTE": "Dodaj belešku",
      "CHANGE_PRIORITY": "Promeni prioritet",
      "ADD_SLA": "Dodaj SLA",
      "SKIP_AUTO_PRIORITY": "Preskoči automatski prioritet",
      "SKIP_AUTO_LABELING": "Preskoči automatsko označavanje",
      "AUTO_TRANSLATE": "Prevedi poruku",
      "AUTO_TRANSLATE_CONVERSATION": "Prevedi razgovor",
      "MOVE_CONVERSATION_TO_INBOX": "Premesti razgovor u prijemni sandučić",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Pošalji poruku u novom razgovoru",
      "SEND_SMS_IN_NEW_CONVERSATION": "Pošalji SMS u novom razgovoru",
      "STOP_PROCESSING_RULES": "Zaustavi obradu pravila"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI filter",
      "MESSAGE_TYPE": "Tip poruke",
      "MESSAGE_CONTAINS": "Sadržaj poruke",
      "EMAIL": "E-pošta",
      "INBOX": "Prijemno sanduče",
      "CHANNEL_TYPE": "Tip prijemnog sandučeta",
      "CONVERSATION_LANGUAGE": "Jezik razgovora",
      "PHONE_NUMBER": "Broj telefona",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Jezik pregledača",
      "MAIL_SUBJECT": "Naslov e-pošte",
      "COUNTRY_NAME": "Zemlja",
      "MARKETPLACE_COUNTRY": "Zemlja marketplejsa",
      "REFERER_LINK": "Veza reference",
      "ASSIGNEE_NAME": "Dodeljeni agent",
      "TEAM_NAME": "Tim",
      "PRIORITY": "Prioritet",
      "CALL_DIRECTION": "Smer poziva",
      "MISSED_CALL": "Propušten poziv",
      "MISSED_CALL_COUNT": "Broj propuštenih poziva",
      "MESSAGE_SOURCE_TYPE": "Tip izvora poruke",
      "INCOMING_MESSAGE_COUNT": "Broj dolaznih poruka",
      "OUTGOING_MESSAGE_COUNT": "Broj izlaznih poruka",
      "LABEL": "Oznaka",
      "EMAIL_RECIPIENTS": "Primalac e-pošte",
      "EMAIL_AUTO_REPLY": "E-pošta je automatski odgovor",
      "ATTACHMENT_EXTENSION": "Ekstenzija priloga",
      "EXTENSION": "Pozvani lokal",
      "WORKING_HOURS": "U radno vreme",
      "AGENT_REPLIED": "Agent je odgovorio od promene statusa"
    },
    "WAIT": {
      "RUN_LABEL": "Pokreni akcije",
      "INSTANT": "Pri događaju",
      "DELAYED": "Sa odlaganjem",
      "TRIGGER_LABEL": "Čekaj dok",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Razgovor ostaje u statusu",
        "CUSTOMER_UNRESPONSIVE": "Klijent ne odgovara agentu",
        "AGENT_UNRESPONSIVE": "Klijent ne dobija odgovor agenta"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Otvoren",
        "PENDING": "Nerešen",
        "SNOOZED": "Odložen",
        "RESOLVED": "Rešen"
      },
      "DELAY_LABEL": "Vreme čekanja",
      "DELAY_ERROR": "Unesite vreme čekanja između 1 minuta i 30 dana",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Akcije se pokreću kada je razgovor u statusu {status} tokom {duration}. Promena statusa pre toga ih otkazuje. Oznake, radno vreme i odgovori agenta proveravaju se kada čekanje istekne.",
        "CUSTOMER_UNRESPONSIVE": "Akcije se pokreću kada klijent ne odgovori {duration} posle poruke agenta. Odgovor klijenta ih otkazuje; nova poruka agenta ponovo pokreće čekanje.",
        "AGENT_UNRESPONSIVE": "Akcije se pokreću kada klijent čeka {duration} bez odgovora agenta. Odgovor agenta ih otkazuje."
      }
    }
  }
}
